import React from 'react'
import Image, { StaticImageData } from 'components/Image'
import classNames from 'classnames'

const LayeredInformationSection = ({
  header,
  image,
  imageAlignment,
  content,
}: {
  header?: string
  image: {
    url: string | StaticImageData
    alt: string
  }
  imageAlignment: 'left' | 'right'
  content: {
    header: string
    content: string
  }[]
}) => {
  return (
    <>
      {header && (
        <hr className="mb-50 lg:mb-150 text-home-divider md:block" />
      )}

      <div className="flex flex-col gap-y-50 lg:gap-y-80 justify-between w-full container-public lg:mt-150 mb-75 xl:mb-150 z-[-1]">
        {header && (
          <h2 className="font-serif font-bold text-center text-grey-900 text-32 md:text-42 lg:text-48 tracking-title leading-title">
            {header}
          </h2>
        )}

        <div className={classNames(
          'flex flex-col w-full lg:flex-row gap-x-20 lg:gap-x-75 xl:gap-x-90 gap-y-20 md:items-center',
          {
            'lg:flex-row-reverse': imageAlignment === 'left',
          },
        )}>
          <div className="w-full lg:max-w-[450px] h-[400px] lg:h-[600px] relative">
            <Image
              src={image.url}
              alt={image.alt}
              layout="fill"
              className="object-cover rounded-4"
            />
          </div>

          <div className="flex flex-col h-full gap-45 mx-auto my-auto max-w-[740px] w-full pt-20 lg:pt-0">
            {
              content.map((item, index) => (
                <div className="flex flex-col gap-y-10" key={index}>
                  <div className="font-serif font-bold text-grey-900 text-28 leading-title tracking-title">
                    {item.header}
                  </div>
                  <div className="text-grey-750 text-16 leading-23">
                    {item.content}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default LayeredInformationSection
